import {button,escapeHtml,message,panel} from '../ui/components.js';
import {FeedbackKind} from './model.js';

function kindLabel(kind){
  return kind===FeedbackKind.IDEA?'Mam pomysł':'Zgłoś problem';
}

export function feedbackPageMarkup({
  kind=FeedbackKind.BUG,
  status='idle',
  messageText='',
  messageKind='neutral',
  pendingCount=0,
  pendingItems=[],
  description='',
  online=true
}={}){
  const feedbackKind=kind===FeedbackKind.IDEA?FeedbackKind.IDEA:FeedbackKind.BUG;
  const bug=feedbackKind===FeedbackKind.BUG;
  const switcher='<div class="actions feedback-kind-switcher">'
    +button({id:'feedback-kind-bug',label:'Zgłoś problem',variant:bug?'primary':'secondary'})
    +button({id:'feedback-kind-idea',label:'Mam pomysł',variant:bug?'secondary':'primary'})
    +'</div>';
  const diagnostics=bug
    ?'<label class="planner-check"><input type="checkbox" name="includeDiagnostics" value="1" checked> '
      +'<span>Dołącz bezpieczny pakiet diagnostyczny</span></label>'
      +'<p class="panel-copy">Pakiet zawiera wyłącznie ograniczone dane techniczne: wersję aplikacji, ekran/moduł, stan sieci/synchronizacji i ostatnie zanonimizowane zdarzenia. Nie dołączamy notatek z Dziennika/Dymka, tokenów, lokalizacji ani zdjęć.</p>'
    :'';
  const attachment=bug
    ?online
      ?'<label class="field"><span class="field-label">Screenshot (opcjonalnie)</span><input type="file" name="attachment" accept="image/jpeg,image/png,image/webp"><small>JPG, PNG lub WebP do 5 MB. Plik zostanie wysłany tylko po wybraniu go przez Ciebie.</small></label>'
      :'<p class="auth-note">Screenshot można dołączyć po odzyskaniu połączenia. Samo zgłoszenie możesz zapisać offline już teraz.</p>'
    :'';
  const pendingItemsMarkup=pendingCount>0
    ?'<div class="feedback-pending"><p class="auth-note">Oczekujące zgłoszenia zapisane lokalnie: '+escapeHtml(pendingCount)+'</p>'
      +(Array.isArray(pendingItems)?pendingItems:[]).map(item=>
        '<div class="actions feedback-pending-item"><span>'+escapeHtml(item.kind==='idea'?'Pomysł':'Problem')+' · '+escapeHtml(item.requestId)+'</span>'
        +button({
          label:'Anuluj oczekujące',
          variant:'ghost',
          attributes:{'data-feedback-cancel-pending':item.requestId}
        })+'</div>'
      ).join('')
      +'</div>'
    :'';
  const busy=status==='submitting';
  const form='<form id="feedback-form" class="smoker-form" novalidate>'
    +'<input type="hidden" name="kind" value="'+escapeHtml(feedbackKind)+'">'
    +'<label class="field"><span class="field-label">'+escapeHtml(kindLabel(feedbackKind))+'</span>'
      +'<textarea name="description" rows="6" maxlength="4000" required placeholder="'
      +escapeHtml(bug?'Opisz co się stało, czego oczekiwałeś i co zobaczyłeś.':'Opisz pomysł i po co byłby przydatny.')
      +'">'+escapeHtml(description)+'</textarea></label>'
    +diagnostics+attachment
    +'<div class="actions">'+button({label:busy?'Wysyłanie…':online?'Wyślij':'Zapisz offline',type:'submit',variant:'primary',loading:busy})
      +button({id:'feedback-cancel',label:'Anuluj',variant:'ghost'})+'</div>'
    +'</form>';

  return switcher
    +message({text:messageText,kind:messageKind})
    +pendingItemsMarkup
    +panel({
      title:kindLabel(feedbackKind),
      subtitle:bug
        ?'Pomóż nam odtworzyć problem bez wysyłania prywatnej treści.'
        :'Pomysły trafiają bez pakietu diagnostycznego, chyba że zgłaszasz osobno problem.',
      label:'Feedback',
      body:form
    });
}
